import { render, staticRenderFns } from "./Duration.vue?vue&type=template&id=228e146c&scoped=true&"
import script from "./Duration.vue?vue&type=script&lang=ts&"
export * from "./Duration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228e146c",
  null
  
)

export default component.exports